import {Main} from '@dms/shared';

import {VehicleRentalDocuments} from '../VehicleRentalDocuments/VehicleRentalDocuments';

export function Documents() {
  return (
    <Main>
      <VehicleRentalDocuments />
    </Main>
  );
}
